var commonStyles = {"component":"tabs__component_chgte","fullWidthScroll":"tabs__fullWidthScroll_chgte","container":"tabs__container_chgte","title":"tabs__title_chgte","xxs":"tabs__xxs_chgte","skeleton":"tabs__skeleton_chgte","xs":"tabs__xs_chgte","s":"tabs__s_chgte","m":"tabs__m_chgte","l":"tabs__l_chgte","xl":"tabs__xl_chgte"};
require('./components/secondary-tablist/index.css');

export { commonStyles as c };
